<ng-container>
    <div *ngIf="root && item.visible !== false" class="layout-menuitem-root-text">{{ item.label }}</div>
    <a *ngIf="(!item.routerLink || item.items) && item.visible !== false" [attr.href]="item.url" (click)="itemClick($event)" [ngClass]="item.styleClass" [attr.target]="item.target" tabindex="0" pRipple>
        <ng-container *ngIf="item.icon">
            <!-- PrimeNG Icon -->
            <i *ngIf="isPrimeIcon(item.icon)" [ngClass]="item.icon" class="layout-menuitem-icon"></i>
            <!-- Material Icon -->
            <span *ngIf="isMaterialIcon(item.icon)" class="material-icons layout-menuitem-icon">
                {{ getMaterialIconName(item.icon) }}
            </span>
            <!-- Material Symbols Icon -->
            <span *ngIf="isMaterialSymbolsIcon(item.icon)" class="material-symbols-outlined layout-menuitem-icon">
                {{ getMaterialIconName(item.icon) }}
            </span>
        </ng-container>
        <span class="layout-menuitem-text">{{ item.label }}</span>
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
    </a>
    <div class="w-full flex flex-row justify-between align-middle items-center">
        <a
        class="w-full"
        *ngIf="item.routerLink && !item.items && item.visible !== false"
        (click)="itemClick($event)"
        [ngClass]="item.styleClass"
        [routerLink]="item.routerLink"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions || { paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
        [fragment]="item.fragment"
        [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment"
        [skipLocationChange]="item.skipLocationChange"
        [replaceUrl]="item.replaceUrl"
        [state]="item.state"
        [queryParams]="item.queryParams"
        [attr.target]="item.target"
        tabindex="0"
        pRipple
    >
        <ng-container *ngIf="item.icon">
            <!-- PrimeNG Icon -->
            <i *ngIf="isPrimeIcon(item.icon)" [ngClass]="item.icon" class="layout-menuitem-icon"></i>
            <!-- Material Icon -->
            <span *ngIf="isMaterialIcon(item.icon)" class="material-icons layout-menuitem-icon">
                {{ getMaterialIconName(item.icon) }}
            </span>
            <!-- Material Symbols Icon -->
            <span *ngIf="isMaterialSymbolsIcon(item.icon)" class="material-symbols-outlined layout-menuitem-icon">
                {{ getMaterialIconName(item.icon) }}
            </span>
        </ng-container>
        <!-- <span class="layout-menuitem-text">{{ item.label }}</span> -->
        <span 
            class="layout-menuitem-text"
            [ngClass]="{ 'no-wrap': !!item['templateId'] }">
            {{
            item['templateId']
                ? (((item.label || '').length > 18) ? ((item.label | slice:0:18) + '...') : item.label)
                : item.label
            }}
        </span>
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler" *ngIf="item.items"></i>
    </a>
    @if(item['templateId']){
        <div class="w-fit" >
            <p-button [rounded]="true" [text]="true" (onClick)="menu.toggle($event)" icon="pi pi-ellipsis-v"/>
            <p-menu #menu [model]="actionItems" [popup]="true" appendTo="body"/>
        </div>
    }
    
    </div>
    <ul *ngIf="item.items && item.visible !== false" [@children]="submenuAnimation">
        <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
            <app-menuitem [item]="child" [index]="i" [parentKey]="key" [class]="child['badgeClass']"></app-menuitem>
            <li *ngIf="child.separator" class="menu-separator-divider"></li>
        </ng-template>
    </ul>
</ng-container>